import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { LiveChat, User } from '@edassist/api';
import { AppConfigService } from '../../app-config/app-config.service';
import { constants } from '../../constants/constants';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ScriptLoadingService } from '../script-loader/script-loading.service';
import { PRODUCT_TYPES } from '../../enums/product-types.enum';
import { DOCUMENT } from '@angular/common';
import { LIVE_CHAT_CONSTANTS } from '../../constants/live-chat.constants';
import { LiveChatMonitorService } from './live-chat-monitor.service';

@Injectable({ providedIn: 'root' })
export class LiveChatUtilityService {
	chatLingualGlobalVariable: string;
	private readonly renderer: Renderer2;

	constructor(
		@Inject(DOCUMENT) readonly document: Document,
		private readonly rendererFactory2: RendererFactory2,
		private readonly scriptLoadingService: ScriptLoadingService,
		private readonly liveChatMonitorService: LiveChatMonitorService
	) {
		// tslint:disable-next-line:no-null-keyword
		this.renderer = this.rendererFactory2.createRenderer(null, null);
	}

	loadChatBox(activeProductId: number, liveChats: Array<LiveChat>, currentUser: User): void {
		const clientDetails = LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS);
		if (clientDetails?.liveChatEnabled) {
			const liveChatApiEndPoint = AppConfigService.getSettings().liveChatEndPoints.api;
			const liveChatWssEndPoint = AppConfigService.getSettings().liveChatEndPoints.wss;
			const liveChatScriptSrc = AppConfigService.getSettings().liveChatEndPoints.script;
			let liveChatId: number;
			if (activeProductId === PRODUCT_TYPES.loan || activeProductId === PRODUCT_TYPES.expertGuidance) {
				liveChatId = clientDetails?.loanLiveChatId;
			} else {
				liveChatId = clientDetails?.liveChatId;
			}
			liveChatId = liveChatId ? liveChatId : LIVE_CHAT_CONSTANTS.defaultLiveChatId;
			const liveChatApiKey = liveChats.find((liveChatConfig) => liveChatConfig.liveChatId === liveChatId)?.apiKey;

			const firstName = currentUser?.firstName;
			const lastName = currentUser?.lastName;
			const employeeId = currentUser?.employeeId;
			const participantId = currentUser?.participantId;
			const clientId = clientDetails?.id;
			const formData = `{firstName: '${firstName}', lastName: '${lastName}',
												 employeeId: '${employeeId}', participantId: '${participantId}',
												 clientId: '${clientId}'}`;
			// As per the ChatLingual Technical Documentation, following sequence is mandatory
			// i.e 'chatbox' JavaScript needs to always load after the config variables are set.
			this.chatLingualGlobalVariable = `var chatlingual = { apiEndpoint: '${liveChatApiEndPoint}', apiKey: '${liveChatApiKey}', wssEndpoint: '${liveChatWssEndPoint}',
													 formData: ${formData} };`;

			this.removeChatBox();

			this.scriptLoadingService.loadJsScript(this.renderer, '', this.chatLingualGlobalVariable, 'script1');
			this.scriptLoadingService.loadJsScript(this.renderer, liveChatScriptSrc, '', 'script2');
			// Initialize the chat listener which encapsulates the logic for detecting the chat-box and sending events to GTM
			// This is done using 'MutationObserver' that watches for DOM changes to ensure that the listener is initialized only after the chat script is loaded.
			this.liveChatMonitorService.initializeChatListener();

			if (this.document.getElementById('cl-chat-widget')) {
				this.document.getElementById('cl-chat-widget').classList.remove('cl-hide');
			}
			sessionStorage.setItem(constants.sessionStorageKeys.CHAT_LINGUAL_INITIALIZED, 'true');
		}
	}

	showChatBox(): void {
		(window as any).cl.showChat(true);
	}

	removeChatBox(): void {
		if (this.document.getElementById('script1')) {
			this.document.getElementById('script1').remove();
		}
		if (this.document.getElementById('script2')) {
			this.document.getElementById('script2').remove();
		}
		sessionStorage.setItem(constants.sessionStorageKeys.CHAT_LINGUAL_INITIALIZED, 'false');
	}
}
